"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Search = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Search.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * SVBCards
 * All these properties are properties  of props
 * @param type: type of the search box
 * @param isClearImageNeeded: weather clear icon inside search box needed or not
 * @returns HTML tag with content
 */

const searchTypesMapping = {
  "search-bar-rounded-large": "searchbar searchbar_large",
  "search-bar-rounded-medium": "searchbar searchbar_medium",
  "search-bar-rounded-small": "searchbar searchbar_small",
  "search-bar-large": "searchbar-no-radius searchbar_large",
  "search-bar-medium": "searchbar-no-radius searchbar_medium",
  "search-bar-small": "searchbar-no-radius searchbar_small"
};
const SVBSearchBars = props => {
  const {
    showIcon = true
  } = props;
  const typeOfSearch = props.searchType ? searchTypesMapping[props.searchType] : "search-bar-rounded-large";
  const isClearImage = props.isClearImageNeeded ? props.isClearImageNeeded : false;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: typeOfSearch
  }, showIcon && /*#__PURE__*/_react.default.createElement("img", {
    src: _Search.default,
    alt: "search icon",
    role: "presentation"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "search",
    id: "searchInputFormControl",
    className: "searchbar_control",
    placeholder: "Search through API Docs, Solutions and more..."
  }), isClearImage ? /*#__PURE__*/_react.default.createElement("div", {
    className: "search_clear"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "search_clear_span"
  }, "/")) : /*#__PURE__*/_react.default.createElement("div", null));
};
var _default = SVBSearchBars;
exports.default = _default;